interface EditIconProps {
  color?: string;
  size?: number;
}

export const EditIcon = ({ color = '#228BE6', size = 16 }: EditIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.19526 3.1953C9.67391 2.71665 10.3231 2.44775 11 2.44775C11.6769 2.44775 12.3261 2.71665 12.8047 3.1953C13.2834 3.67395 13.5523 4.32313 13.5523 5.00004C13.5523 5.67695 13.2834 6.32613 12.8047 6.80478L5.80474 13.8048C5.67971 13.9298 5.51014 14 5.33333 14H2.66667C2.29848 14 2 13.7016 2 13.3334V10.6667C2 10.4899 2.07024 10.3203 2.19526 10.1953L8.52429 3.86627C8.52572 3.86482 8.52715 3.86337 8.5286 3.86193C8.53004 3.86049 8.53149 3.85905 8.53294 3.85763L9.19526 3.1953ZM9.00002 5.27616L3.33333 10.9428V12.6667H5.05719L10.7239 7.00002L9.00002 5.27616ZM11.6667 6.05721L9.94283 4.33335L10.1381 4.13811C10.3667 3.90951 10.6767 3.78109 11 3.78109C11.3233 3.78109 11.6333 3.90951 11.8619 4.13811C12.0905 4.36671 12.219 4.67675 12.219 5.00004C12.219 5.32333 12.0905 5.63337 11.8619 5.86197L11.6667 6.05721Z"
      fill={color}
    />
  </svg>
);

export const WarningIcon = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.23525 6.46695C2.66958 4.61534 4.11534 3.16958 5.96696 2.73525C7.30417 2.42158 8.69583 2.42158 10.033 2.73525C11.8847 3.16958 13.3304 4.61534 13.7648 6.46696C14.0784 7.80417 14.0784 9.19583 13.7648 10.533C13.3304 12.3847 11.8847 13.8304 10.033 14.2648C8.69583 14.5784 7.30417 14.5784 5.96696 14.2647C4.11534 13.8304 2.66958 12.3847 2.23525 10.533C1.92158 9.19583 1.92158 7.80417 2.23525 6.46695Z"
        stroke="#DF4141"
        strokeWidth="1.6"
      />
      <path
        d="M8 10.8334V8.16675"
        stroke="#DF4141"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="7.99992" cy="6.49992" r="0.666667" fill="#DF4141" />
    </svg>
  );
};

export const LoadingCircle = () => {
  return (
    <span className="custom-spinner">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10Z"
          fill="#A5D8FF"
        />
        <path
          d="M16.4648 17.6293C15.4629 18.4783 14.3036 19.1216 13.053 19.5225C11.8025 19.9235 10.4853 20.0742 9.17653 19.966C7.86777 19.8579 6.59313 19.493 5.42537 18.8923C4.25762 18.2915 3.21963 17.4667 2.37066 16.4648L3.89653 15.1718C4.5757 15.9733 5.4061 16.6332 6.3403 17.1138C7.2745 17.5944 8.29422 17.8863 9.34122 17.9728C10.3882 18.0593 11.442 17.9388 12.4424 17.618C13.4429 17.2973 14.3703 16.7826 15.1718 16.1035L16.4648 17.6293Z"
          fill="#228BE6"
        />
      </svg>
    </span>
  );
};
